import { State } from '../state';

export const PxdbDeviceSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    deviceRegistration: (state: State) => state.PxdbDevice,
};
